import { render, staticRenderFns } from "./SessionLayout.vue?vue&type=template&id=51c0c622&"
import script from "./SessionLayout.vue?vue&type=script&lang=js&"
export * from "./SessionLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports